import { RESEND_MAIL, RESEND_MAIL_SUCCESS, RESEND_MAIL_ERROR, RESEND_MAIL_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ResendMail = (state = initialState, action) => {
  switch (action.type) {
    case RESEND_MAIL:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case RESEND_MAIL_SUCCESS:
      state = {
        ...state,
        data: null,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case RESEND_MAIL_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case RESEND_MAIL_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ResendMail;
